import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer
      className="mt-24 border-t border-line bg-[#f4f1ec]"
      data-testid="site-footer"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-2">
            <img
              src="/assets/logo/arel-logo.png"
              alt="AREL Nepal — Energizing Life"
              className="h-12 w-auto"
            />
            <p className="mt-6 max-w-md text-sm leading-relaxed text-muted-warm">
              AREL Nepal Pvt Ltd — Energizing Life. Smart LED TVs, air
              conditioners, washing machines, chest freezers and air coolers
              engineered with premium global partners for Nepali homes and
              shops. Official importer of Daikin Air Conditioners in Nepal.
            </p>
            <div className="mt-6 flex gap-3">
              <a
                href="https://www.facebook.com/share/1NfGTfqoUc/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-facebook"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-line-strong text-[#575761] transition-colors duration-300 ease-out hover:border-[#dd0447] hover:text-[#dd0447]"
              >
                <Facebook className="h-4 w-4" />
              </a>
              <a
                href="https://www.instagram.com/arel.nepal/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-social-instagram"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-line-strong text-[#575761] transition-colors duration-300 ease-out hover:border-[#dd0447] hover:text-[#dd0447]"
              >
                <Instagram className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div>
            <div className="overline mb-4">Explore</div>
            <ul className="space-y-3 text-sm text-muted-warm">
              <li><Link data-testid="footer-link-products" to="/products" className="hover:text-ink">All Products</Link></li>
              <li><Link data-testid="footer-link-daikin" to="/daikin" className="hover:text-ink">Daikin ACs</Link></li>
              <li><Link data-testid="footer-link-categories" to="/categories" className="hover:text-ink">Categories</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-ink">About Us</Link></li>
              <li><Link data-testid="footer-link-dealer" to="/dealer" className="hover:text-ink">Become a Dealer</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-ink">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline mb-4">Get in touch</div>
            <ul className="space-y-3 text-sm text-muted-warm">
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#dd0447]" />
                <span>Biratnagar, Nepal</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#dd0447]" />
                <a href="tel:+9779820755721" className="hover:text-ink">+977-9820755721</a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#dd0447]" />
                <a href="mailto:arelnepal@gmail.com" className="hover:text-ink">arelnepal@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="section-divider my-12" />

        <div className="flex flex-col items-start justify-between gap-4 text-xs text-[#8a857c] md:flex-row md:items-center">
          <div>© {new Date().getFullYear()} AREL Nepal Pvt Ltd. All rights reserved.</div>
          <div className="flex items-center gap-6">
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-ink">
              Admin
            </Link>
            <span>Energizing Life · Made in Nepal.</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
